import React from 'react';
import { Box } from '@mui/material';

type FigmaGlyphProps = {
  src: string;
  width: number;
  height: number;
  /** Transform on the wrapper. The SVG root size stays the authored width and height. */
  transform?: string;
};

export function FigmaGlyph({ src, width, height, transform }: FigmaGlyphProps) {
  const img = (
    <img
      src={src}
      width={width}
      height={height}
      alt=""
      draggable={false}
      style={{ display: 'block', flexShrink: 0 }}
    />
  );
  if (!transform) return img;
  return (
    <Box component="span" sx={{ display: 'inline-flex', lineHeight: 0, transform }}>
      {img}
    </Box>
  );
}

/** Figma chevron asset points left; the frames rotate it −90° so it points down. */
export function EditorChevronIcon({ className }: { className?: string }) {
  return (
    <Box
      component="span"
      className={className}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 18,
        height: 18,
        top: 'calc(50% - 9px) !important',
        transform: 'rotate(-90deg)',
      }}
    >
      <img
        src="/images/editor/icon-chevron.svg"
        width={18}
        height={18}
        alt=""
        draggable={false}
        style={{ display: 'block' }}
      />
    </Box>
  );
}
